import request from '../untils/request';

export const systemPurviewListApi = params => {
  return request({
    url: '/system/user-purview/index',
    params,
    authCode:'USER-PURVIEW_INDEX'
  });
};

export const systemPurviewParentListApi = params => {
  return request({
    url: '/system/user-purview/parent-list',
    params,
  });
};

export const systemPurviewDeleteApi = params => {
  return request({
    url: '/system/user-purview/delete',
    params,
  });
};

export const systemPurviewCreateApi = params => {
  return request({
    url: '/system/user-purview/create',
    params,
  });
};

export const systemPurviewUpdateApi = params => {
  return request({
    url: '/system/user-purview/update',
    params,
  });
};

export const systemOrganizationListApi = params => {
  return request({
    url: '/system/department/index',
    authCode:'DEPARTMENT_INDEX',
    params,
  });
};

export const systemOrganizationIdListApi = params => {
  return request({
    url: '/system/department/id-list',
    authCode:'DEPARTMENT_INDEX',
    params,
  });
};

export const systemOrganizationDelApi = params => {
  return request({
    url: '/system/department/delete',
    authCode:'DEPARTMENT_INDEX',
    params,
  });
};

export const systemOrganizationUpdateApi = params => {
  return request({
    url: '/system/department/save',
    authCode:'DEPARTMENT_INDEX',
    params,
  });
};

export const systemOrganizationTreeApi = params => {
  return request({
    url: '/system/department/tree',
    params,
  });
};

export const systemOrganizationDetailApi = params => {
  return request({
    url: '/system/department/detail',
    authCode:'USER-ROLE_INDEX',
    params,
  });
};

export const systemUserListApi = params => {
  return request({
    url: '/system/user/list',
    params,
  });
};

export const systemUserRoleListApi = params => {
  return request({
    url: '/system/user-role/index',
    authCode:'USER-ROLE_INDEX',
    params,
  });
};

export const systemGetAllCodesListApi = params => {
  return request({
    url: '/system/user-role/get-purview-list',
    params,
  });
};

export const systemUserRolesApi = params => {
  return request({
    url: '/system/user-role/tree',
    params,
  });
};

export const systemUserRoleDetailApi = params => {
  return request({
    url: '/system/user-role/detail',
    params,
  });
};

export const systemUserRoleSaveApi = params => {
  return request({
    url: '/system/user-role/save',
    params,
  });
};

export const systemUserRoleDeleteApi = params => {
  return request({
    url: '/system/user-role/delete',
    params,
  });
};

export const systemUserRoleOperateApi = params => {
  return request({
    url: '/system/user-role/operate',
    params,
  });
};

export const systemUsersListApi = params => {
  return request({
    url: '/system/user/index',
    authCode:'USER_INDEX',
    params,
  });
};

export const systemUsersResetApi = params => {
  return request({
    url: '/system/user/reset',
    params,
  });
};

export const systemUsersOperateApi = params => {
  return request({
    url: '/system/user/operate',
    params,
  });
};

export const systemUsersSaveApi = params => {
  return request({
    url: '/system/user/save',
    params,
  });
};

export const systemUsersDetailApi = params => {
  return request({
    url: '/system/user/detail',
    params,
  });
};

export const systemAdminLogsApi = params => {
  return request({
    url: '/system/admin-log/index',
    authCode:'ADMIN-LOG_INDEX',
    params,
  });
};

export const systemAppVersionsApi = params => {
  return request({
    url: '/system/app-version/index',
    authCode:'APP-VERSION_INDEX',
    params,
  });
};

export const systemAppVersionsOperateApi = params => {
  return request({
    url: '/system/app-version/operate',
    params,
  });
};

export const systemAppVersionsSaveApi = params => {
  return request({
    url: '/system/app-version/save',
    params,
  });
};

export const systemOrganizationOperateApi = params => {
  return request({
    url: '/system/department/operate',
    params,
  });
};

export const systemDepartmentDeleteApi = params => {
  return request({
    url: '/system/department/delete',
    params,
  });
};

export const systemDepartmentCancelBindApi = params => {
  return request({
    url: '/system/user/cancel-bind',
    params,
  });
};

export const systemGrayTaskListApi = params => {
  return request({
    url: '/system/gray-test/task-list',
    params,
  });
};

export const systemGrayWhiteListApi = params => {
  return request({
    url: '/system/gray-test/whitelist',
    params,
  });
};

export const systemGrayEditTaskApi = params => {
  return request({
    url: '/system/gray-test/edit-task',
    params,
  });
};

export const systemGrayAddTaskApi = params => {
  return request({
    url: '/system/gray-test/add-task',
    params,
  });
};

export const systemGrayTaskDelApi = params => {
  return request({
    url: '/system/gray-test/delete-task',
    params,
  });
};

export const systemGrayWhiteListAddApi = params => {
  return request({
    url: '/system/gray-test/add-whitelist-member',
    params,
  });
};

export const systemGrayWhiteListEditApi = params => {
  return request({
    url: '/system/gray-test/edit-whitelist-member',
    params,
  });
};

export const systemGrayWhiteListDelApi = params => {
  return request({
    url: '/system/gray-test/delete-whitelist-member',
    params,
  });
};

export const systemRedisSearchApi = params => {
  return request({
    url: '/system/redis-search/index',
    authCode:'SYSTEM-REDIS-SEARCH_INDEX',
    params,
  });
};

export const systemRedisDeleteApi = params => {
  return request({
    url: '/system/redis-search/delete',
    params,
  });
};

export const systemGrayDelRecordApi = params => {
  return request({
    url: '/system/gray-test/delete-record-old',
    params,
  });
};

export const systemRedisOrderConfigApi = params => {
  return request({
    url: '/system/redis-order-config/index',
    params,
  });
};

export const systemAddMachineApi = params => {
  return request({
    url: '/system/redis-order-config/add-machine',
    params,
  });
};

export const systemGrayTestSaveApi = params => {
  return request({
    url: '/system/redis-order-config/gray-test-save',
    params,
  });
};

export const systemFrequentMachineApi = params => {
  return request({
    url: '/system/redis-order-config/machine-status',
    params,
  });
};

export const systemGrayDelAllRecordApi = params => {
  return request({
    url: '/system/gray-test/delete-record-all',
    params,
  });
};

export const systemRedisEnableConfigApi = params => {
  return request({
    url: '/system/redis-order-config/enable-config',
    params,
  });
};


export const systemRedisConfigListApi = params => {
  return request({
    url: '/system/redis-order-config/config-list',
    params,
  });
};

export const systemRedisSwitchSaveApi = params => {
  return request({
    url: '/system/redis-order-config/switch-save',
    params,
  });
};

export const systemRedisGrayTestSaveApi = params => {
  return request({
    url: '/system/redis-order-config/gray-test-save',
    params,
  });
};

export const systemRedisPanelTabsApi = params => {
  return request({
    url: '/system/redis-order-config/stat-tabs',
    params,
  });
};

export const systemRedisCachePanelTabsApi = params => {
  return request({
    url: '/system/redis-cache/stat-tabs',
    params,
  });
};

export const systemRedisPanelDetailApi = params => {
  return request({
    url: '/system/redis-order-config/redis-stat',
    params,
  });
};

export const systemCleanGrayRecordApi = params => {
  return request({
    url: '/system/redis-order-config/clean-gray-record',
    params,
  });
};

export const systemDelGrayRecordApi = params => {
  return request({
    url: '/system/redis-order-config/delete-config',
    params,
  });
};

export const systemRedisEditConfigApi = params => {
  return request({
    url: '/system/redis-order-config/edit-config',
    params,
  });
};

export const systemRedisDestoryConfigApi = params => {
  return request({
    url: '/system/redis-order-config/destroy-redis',
    params,
  });
};

export const systemRedisCacheDestoryConfigApi = params => {
  return request({
    url: '/system/redis-cache/destroy-redis',
    params,
  });
};


export const systemGrayTestFinishApi = params => {
  return request({
    url: '/system/gray-test/finish',
    params,
  });
};

